import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScopeSequenceStandard } from 'src/app/services/graphql/scope-sequence-standards-response';
import { BehaviorSubject } from 'rxjs';
import { GraphqlService } from 'src/app/services/graphql/graphql.service';
import { ScopeSequenceTabs } from '../models/scope-sequence-tab.model';
import { ScopeSequenceSkill } from 'src/app/services/graphql/scope-sequence-skills-response';
import { StandardService } from 'src/app/services/scope-sequence/standard.service';

@Component({
  selector: 'app-standard',
  templateUrl: './standard.component.html',
  styleUrls: ['./standard.component.scss']
})
export class StandardComponent implements OnInit {
  public hasFreckle: boolean = false;
  public hasSavvas: boolean = false;
  public selectedStandard: ScopeSequenceStandard | null = null;
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selectedTab: ScopeSequenceTabs = ScopeSequenceTabs.Core;
  public skills: ScopeSequenceSkill[] = [];

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private graphqlService: GraphqlService,
    private standardService: StandardService
  ) { }

  public async ngOnInit(): Promise<void> {
    this.isLoading$.next(true);

    await this.setupStandard();
    await this.getSkills();

    this.isLoading$.next(false);
  }

  public updateSelectedTab(tab: ScopeSequenceTabs): void {
    this.selectedTab = tab;
  }

  public isCoreSelected(): boolean {
    return this.selectedTab === ScopeSequenceTabs.Core;
  }

  public isEnrichmentSelected(): boolean {
    return this.selectedTab === ScopeSequenceTabs.Enrichment;
  }

  public isPrerequisiteSelected(): boolean {
    return this.selectedTab === ScopeSequenceTabs.Prerequisite;
  }

  public backClicked(): void {
    this.router.navigate([`/plan-instruction`]);
  }

  private async getSkills(): Promise<void> {
    if (this.selectedStandard != null) {
      this.skills = await this.standardService.getScopeSequenceSkills(this.selectedStandard.standardId);
    }
  }

  private async setupStandard(): Promise<void> {
    let standardId = this.route.snapshot.paramMap.get('standardId') || '';
    const scopeAndSequenceStandards = await this.graphqlService.getScopeSequenceStandard(standardId);

    this.selectedStandard = scopeAndSequenceStandards?.length > 0 ? scopeAndSequenceStandards[0] : null;
  }
}
